import { render } from "./LogistsCompareChart.vue?vue&type=template&id=8c3b4636&scoped=true"
import script from "./LogistsCompareChart.vue?vue&type=script&lang=js"
export * from "./LogistsCompareChart.vue?vue&type=script&lang=js"

import "./LogistsCompareChart.vue?vue&type=style&index=0&id=8c3b4636&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c3b4636"]])

export default __exports__